import { render, staticRenderFns } from "./qschool.vue?vue&type=template&id=58edff10&scoped=true"
import script from "./qschool.vue?vue&type=script&lang=js"
export * from "./qschool.vue?vue&type=script&lang=js"
import style0 from "./qschool.vue?vue&type=style&index=0&id=58edff10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58edff10",
  null
  
)

export default component.exports